import { Component, EventEmitter, Inject, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import { getFirebaseBackend } from 'src/app/authUtils';
import { User } from 'src/app/core/models/auth.models';
import { DataService } from 'src/app/core/services/data.service';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import { DisposService } from 'src/app/services/dispos/dispos.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';
import { RecordsService } from 'src/app/services/records-service/records.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-choose-dispo',
	templateUrl: './choose-dispo.component.html',
	styleUrls: ['./choose-dispo.component.scss'],
})
export class ChooseDispoComponent implements OnInit {
	payload: any;
	dispoForm: FormGroup;
	public user: User = null;
	public from_dbreset = false;
	@Output() back = new EventEmitter<any>();
	public campaign: any = {
		leads_needed: 1,
	};
	campaignId: string;
	campaignAlias: string;
	public prospectId: number = null;
	public recordLoading: boolean = false;
	isLoading = false;

	badPhoneOptions = [
		{ value: 'FAX', label: '📠 FAX', description: 'I Heard Fax Noise.' },
		{ value: 'BUSY', label: '📶 BUSY', description: 'I Heard A Busy Signal.' },
		{ value: 'DISCO', label: '🛑 DISCO', description: 'This Phone Number Has Been Disconnected.' },
		{ value: 'NOTINT', label: '🚫 NOTINT', description: 'This record is not interested.' },
		{ value: 'WRONG', label: '🚫 WRONG', description: 'Wrong Phone Number.' },
		{ value: 'DONOTCALL', label: '🚫 DONOTCALL', description: 'This record is not interested.' },
		{ value: 'NOMARKET', label: '🚫 NOMARKET', description: 'This record is not in the market.' },
	];

	noAnswerOptions = [
		{ value: 'NOMSG', label: '📩 NOMSG', description: 'I Got Voicemail and DID NOT Leave a Message.' },
		{ value: 'MSG', label: '📩 MSG', description: 'I Got Voicemail and DID Leave a Message.' },
		{ value: 'GKINFO', label: '© GKINFO', description: 'Gatekeeper Took My Information. Did Not Transfer.' },
		{ value: 'NOANS', label: '🔔 NOANS', description: 'The Phone Just Kept Ringing. Nobody Answered.' },
		{ value: 'TREE', label: '🌲 TREE', description: 'I Got Stuck in a Phone Tree. Nowhere to Go.' },
	];

	callBackOptions = [
		{ value: 'HOT', label: '🔥 HOT', description: 'Hot Callback.' },
		{ value: 'FYI', label: 'ℹ️ FYI', description: 'For Your Info (record info for client)' },
		{ value: 'SINFO', label: '✉️ SINFO', description: 'Prospect request more info from client' },
	];

	leadOptions = [
		{ value: 'FACE', label: '💰 FACE', description: 'I Got a Face to Face Appointment!' },
		{ value: 'PHONE', label: '💰 PHONE', description: 'I Got a Phone Appointment!' },
		{ value: 'ZOOM', label: '✉️ ZOOM', description: 'I Got a Zoom Call' },
		{ value: 'FIX', label: '🛠 FIX', description: 'I fixed an appointment I already set.' },
	];

	public prospect: any = null;

	public selectedCallbackDate: dayjs.Dayjs;

	public callBackQuantity: number;
	public callBackTimeType: any;
	public callBackButtons: any;
	public callBackStatus: string;

	public type: string = '';

	email1: string | null = null;
	public sendingEmail: boolean;
	@ViewChild('modalCallback') modalCallback!: TemplateRef<any>;
	@ViewChild('modalFYI') modalFYI!: TemplateRef<any>;
	@ViewChild('modalSINFO') modalSINFO!: TemplateRef<any>;

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private disposSrv: DisposService,
		private route: ActivatedRoute,
		private prospectsSrv: ProspectsService,
		private modalSrv: NgbModal,
		private campaignSrv: CampaignsService,
		public utilsSrv: UtilsService,
		public dataSrv: DataService,
		public recordSrv: RecordsService,
		public userSrv: UserService,
		private loaderSrv: LoaderService,
	) {
		const nav = this.router.getCurrentNavigation();
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.payload = nav?.extras?.state?.['payload'];

		this.callBackButtons = {
			tomorrow: false,
			next_week: false,
			next_month: false,
		};

		this.callBackQuantity = 0;
		this.selectedCallbackDate = dayjs();
	}

	ngOnInit(): void {
		this.loaderSrv.loading$.subscribe((loading) => {
			this.isLoading = loading;
		});

		const stateData = history.state?.prospectData;
		this.payload = stateData || this.prospectsSrv.getCurrentProspect();

		this.prospect = this.payload;
		this.userSrv.saveAction('Open Dispo');
		this.route.paramMap.subscribe((params) => {
			this.campaignId = params.get('campaign_id') || '0';
			this.campaignAlias = params.get('alias') || '0';

			this.prospectsSrv.currentCampaignId = this.campaignId;
			this.prospectsSrv.currentCampaignAlias = this.campaignAlias;

			this.dispoForm = this.fb.group({
				dispo: ['', Validators.required],
			});
			this.campaignSrv.getCampaignAndInfoById(this.campaignId).subscribe({
				next: (data: any) => {
					this.campaign = data.body;
					this.email1 = this.campaign?.email1 || null;
				},
				error: (err) => console.error(err),
			});
		});
	}

	dispoHotCallback() {
		if (!this.prospect) {
			Swal.fire('Error', 'No prospect selected.', 'error');
			return;
		}

		if (!this.user) {
			Swal.fire('Error', 'No user authenticated.', 'error');
			return;
		}

		if (!this.campaign || !this.campaign.id) {
			Swal.fire('Error', 'Campaign not loaded yet.', 'error');
			return;
		}

		if (!this.selectedCallbackDate) {
			Swal.fire('Error', 'Callback date is not set.', 'error');
			return;
		}

		this.recordLoading = true;

		if (this.selectedCallbackDate.format('YYYY-MM-DD') != dayjs().format('YYYY-MM-DD')) {
			const dispo = {
				prospect: this.prospect.prospectId,
				primary_phone: this.prospect.primary_phone,
				dispo: this.callBackStatus,
				userId: (this.user as any)?.IdUser ?? 0,
				campaign: this.campaignId,
				date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
				callback_date: this.selectedCallbackDate.format('YYYY-MM-DD HH:mm:ss'),
				notes: this.prospect.notes || '',
				create_callback: true,
			};

			this.updateProspect().subscribe({
				next: () => console.info('Prospect actualizado antes del hot callback'),
				error: () => console.error('❌ Error actualizando prospect'),
			});

			this.disposSrv.hotCallBack(dispo).subscribe({
				next: (response) => {

					const resp = typeof response === 'string' ? JSON.parse(response) : response;

					const success = resp.success ?? resp.result?.status === 'success';
					const dispoId = resp.result?.insertId;

					const primaryPhone = this.payload?.primary_phone || '';
					const campaign = this.campaignId || '0';
					const campaignAlias = this.payload?.campaignAlias || '0';

					if (success && dispoId) {
						this.userSrv.saveAction(`Dispo: ${dispoId}, PrimaryPhone: ${primaryPhone}`);

						Swal.fire('✅ Success', resp.message || 'Hot Callback saved successfully.', 'success').then(() => {
							// const dispoId = resp.body.insertId;

							this.userSrv.saveAction(`Dispo: ${dispoId}, PrimaryPhone: ${primaryPhone}`);
							this.router.navigate(['/prospect-info', campaign, campaignAlias]).then(() => {
								window.location.reload();
							});
						});
					} else {
						Swal.fire('❌ Error', resp.message || 'Hot Callback could not be saved.', 'error');
					}

					this.selectedCallbackDate = dayjs();
					this.callBackQuantity = 0;
					this.callBackTimeType = 'day';
					this.callBackButtons = {
						tomorrow: false,
						next_week: false,
						next_month: false,
					};
					this.callBackStatus = '';
					this.modalSrv.dismissAll();
					this.recordLoading = false;
				},
				error: (error) => {
					console.error('❌ Error saving disposition:', error);
					Swal.fire('Error', 'There was a problem saving the disposition', 'error');
					this.recordLoading = false;
				},
			});

			this.setCalledCallback();
		} else {
			Swal.fire({
				title: 'HOT CALLBACK',
				text: 'Please select another date. A callback cannot be scheduled for the same day.!',
				icon: 'warning',
				showCancelButton: false,
				confirmButtonText: 'Ok',
			});
		}
	}

	onSubmit(): void {
		if (this.selectedDispo) {
		} else {
			console.warn('❗No disposition selected.');
		}
	}

	onExit(): void {
		Swal.fire({
			title: 'Exit this campaign?',
			text: 'Are you sure you want to leave this section?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, exit',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.assign('/');
			}
		});
	}

	onBack(): void {
		if (this.dispoForm) {
			this.payload.dispo = this.dispoForm.get('dispo')?.value || this.selectedDispo || null;
		}

		this.router.navigate(['/prospect-info', this.payload.campaign_id, this.payload.campaign_alias], { state: { payload: this.payload } });
	}
	selectedDispo: string | null = null;

	selectDispo(value: string): void {
		this.selectedDispo = value;
		this.onSubmit();
	}
	selectBadPhoneDispo(value: string): void {
		this.loaderSrv.show();

		this.selectedDispo = value;
		this.dispoForm.patchValue({ dispo: value });
		this.payload.dispo = value;

		this.payload.campaign = this.payload.campaign_id || this.payload.campaignId || '0';
		this.payload.prospect = this.payload.prospectId || this.payload.prospect;

		const campaign = this.payload?.campaign_id || '0';
		const campaignAlias = this.payload?.campaign_alias || '0';

		const primaryPhone = this.payload?.primary_phone || '';

		this.disposSrv.saveDispo(this.payload).subscribe({
			next: (response: any) => {
				this.loaderSrv.hide();

				if (response.success && response.body?.insertId) {
					const dispoId = response.body.insertId;

					this.userSrv.saveAction(`Dispo: ${dispoId}, PrimaryPhone: ${primaryPhone}`);

					Swal.fire('✅ Success', 'Disposition saved successfully.', 'success').then(() => {
						this.router.navigate(['/prospect-info', campaign, campaignAlias]).then(() => {
							window.location.reload();
						});
					});
				} else {
					Swal.fire('❌ Error', 'Disposition could not be saved.', 'error');
				}
			},
			error: (error) => {
				this.loaderSrv.hide();
				console.error('❌ Error saving disposition:', error);
				Swal.fire('Error', 'There was a problem saving the disposition', 'error');
			},
		});

		this.onSubmit();
	}

	selectNoAnswerDispo(value: string): void {
		this.loaderSrv.show();
		this.selectedDispo = value;
		this.dispoForm.patchValue({ dispo: value });
		this.payload.dispo = value;

		this.payload.campaign = this.payload.campaign_id || this.payload.campaignId || '0';
		this.payload.prospect = this.payload.prospectId || this.payload.prospect;

		const campaign = this.payload?.campaign_id || '0';
		const campaignAlias = this.payload?.campaign_alias || '0';

		this.disposSrv.saveDispo(this.payload).subscribe({
			next: (response) => {
				this.loaderSrv.hide();
				if (response.success) {
					Swal.fire('✅ Success', 'Disposition saved successfully.', 'success').then(() => {
						this.router.navigate(['/prospect-info', campaign, campaignAlias]).then(() => {
							window.location.reload();
						});
					});
				} else {
					Swal.fire('❌ Error', 'Disposition could not be saved.', 'error');
				}
			},
			error: (error) => {
				this.loaderSrv.hide();
				console.error('❌ Error saving disposition:', error);
				Swal.fire('Error', 'There was a problem saving the disposition', 'error');
			},
		});

		this.onSubmit();
	}

	selectLeadDispo(value: string): void {
		this.selectedDispo = value;
		this.dispoForm.patchValue({ dispo: value });

		this.payload = this.payload || {};

		this.payload.dispo = value;
		this.payload.campaign_timezone = this.campaign?.timezone || null;

		this.prospectsSrv.setCurrentProspect(this.payload);

		this.router.navigate(['/appointment-form', this.campaignId, this.campaignAlias], {
			state: { prospectData: this.payload },
		});
	}

	modalHotCallBack(modalCallback, status) {
		this.callBackStatus = status;
		this.modalSrv.open(modalCallback, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' }).result.then(
			(result) => {
				console.info(result);
			},
			(reason) => {
				console.info(reason);
			},
		);
	}

	modalFYIfunc(modal) {
		this.modalSrv.open(modal, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' }).result.then(
			(result) => {
				console.info(result);
			},
			(reason) => {
				console.info(reason);
			},
		);
	}

	modalSINFOfunc(modal) {
		if (this.payload.primary_email == '' || this.payload.primary_email === null) {
			Swal.fire("There's no email of prospect", "You cannot use this dispo, because the prospect doesn't have an email", 'error');
		} else {
			this.modalSrv.open(modal, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' }).result.then(
				(result) => {
					console.info(result);
				},
				(reason) => {
					console.info(reason);
				},
			);
		}
	}

	setDateChange() {
		this.selectedCallbackDate = dayjs().add(this.callBackQuantity, this.callBackTimeType);
		this.callBackButtons.tomorrow = false;
		this.callBackButtons.next_week = false;
		this.callBackButtons.next_month = false;
	}

	setCallBackDate(button) {
		switch (button) {
			case 'tomorrow':
				this.selectedCallbackDate = dayjs().add(1, 'day');
				this.callBackTimeType = 'day';
				this.callBackButtons.tomorrow = true;
				this.callBackButtons.next_week = false;
				this.callBackButtons.next_month = false;
				break;
			case 'next_week':
				this.selectedCallbackDate = dayjs().add(1, 'week');
				this.callBackTimeType = 'week';
				this.callBackButtons.tomorrow = false;
				this.callBackButtons.next_week = true;
				this.callBackButtons.next_month = false;
				break;
			case 'next_month':
				this.selectedCallbackDate = dayjs().add(1, 'month');
				this.callBackTimeType = 'month';
				this.callBackButtons.tomorrow = false;
				this.callBackButtons.next_week = false;
				this.callBackButtons.next_month = true;
				break;
			default:
				break;
		}
		this.callBackQuantity = 1;
		this.setCalledCallback();
	}

	updateProspect() {
		return this.disposSrv.updateProspect(this.prospect);
	}

	setCalledCallback() {
		if (this.type === 'callback') {
			console.info('dispo id', this.route.snapshot.queryParams['dispoId']);
			this.disposSrv.setCallbackAsCalled(this.route.snapshot.queryParams['dispoId']).then((data) => { });
		}
	}

	formatCallBackDate() {
		return this.selectedCallbackDate.format('MMMM D, YYYY');
	}

	dispoFYI() {
		const dispo = {
			prospect: this.prospect.prospectId,
			primary_phone: this.prospect.primary_phone,
			dispo: 'FYI',
			userId: (this.user as any)?.IdUser ?? 0,
			campaign: this.campaign.id,
			date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
			callback_date: this.selectedCallbackDate.format('YYYY-MM-DD HH:mm:ss'),
			notes: this.prospect.notes,
			create_callback: true,
		};
		this.sendingEmail = true;
		this.fyiSendEmail(dispo);
		this.setCalledCallback();
	}

	fyiSendEmail(dispo: any) {
		this.updateProspect().subscribe({
			next: () => {
				const url = environment.api + 'dispos/send_FYI.php';
				const payload = { prospect: this.prospect, alias: this.campaign.alias, dispo: dispo };

				this.dataSrv.postObservableSimple(url, payload).subscribe({
					next: (data) => {
						this.sendingEmail = false;
						this.modalSrv.dismissAll();
						// this.getNewRecordToDial();
						// this.setCalledCallback();
					},
					error: (err) => {
						console.error('Error sending email:', err);
						this.sendingEmail = false;
					},
				});
			},
			error: (err) => {
				console.error('Error updating prospect:', err);
			},
		});
	}

	selectCallBackDispo(value: string) {
		this.selectedDispo = value;
		this.dispoForm.patchValue({ disposition: value });

		switch (value) {
			case 'HOT':
				this.modalSrv.open(this.modalCallback, { centered: true });
				break;
			case 'FYI':
				this.modalSrv.open(this.modalFYI, { centered: true });
				break;
			case 'SINFO':
				this.modalSrv.open(this.modalSINFO, { centered: true });
				break;
		}
	}
}
